<fieldset [hidden]="isBrowserSupported" class="warning">
  <legend>{{ 'Login.Warning' | translate }}</legend>
  {{ 'Login.IEWarning' | translate }}
</fieldset>
